import React, { useEffect, useRef } from "react";
import { useRollbar } from "@rollbar/react";

import { useIncode } from "./IncodeContext";
import { incodeUiConfig } from "./incodeRequest";

export const CaptureFace = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const rendererRef = useRef<{ close?: () => void } | undefined>(undefined);
  const { incode, token, track, navigateTo, onComplete } = useIncode();
  const rollbar = useRollbar();

  useEffect(() => {
    rendererRef.current = incode.renderCaptureFace(containerRef.current, {
      session: { token },
      onSuccess: async () => {
        try {
          await incode.processFace({ token });
          await incode.getFinishStatus(null, { token });
          track("selfie_success");
          onComplete();
        } catch (error) {
          rollbar.error("Incode Face Capture Error", error);
          track("selfie_error");
          onComplete();
        }
      },
      onError: async (error: any) => {
        rollbar.error("Incode Render Capture Face Error", error);

        if (error.code === "PERMISSION_DENIED") {
          track("selfie_permissions_error");
          navigateTo("enable_camera_access");
          return;
        }

        try {
          await incode.processFace({ token });
          await incode.getFinishStatus(null, { token });
        } catch (processError) {
          rollbar.error("Incode Process Face Error (after capture error)", processError);
        }

        track("selfie_error");
        onComplete();
      },
      forceV2: true,
      throwOnCameraPermissionDenied: true,
      uiConfig: incodeUiConfig,
    });

    return () => {
      rendererRef.current?.close?.();
    };
  }, [incode, token, track, navigateTo, onComplete, rollbar]);

  return <div ref={containerRef} />;
};
